// extracted by css-extract-rspack-plugin
var _1 = "AULX44E6BYKakducjayrwA--";
var _2 = "OoeinOXcACDnnKqPA7un3A--";
var _3 = "bWg3HSt214bliBE7zgVm5g--";
var _4 = "bklq4nAmt1eSldSVdeGPbg--";
var _5 = "eP759G22AylXt6xtLkkxyQ--";
var _6 = "-GouM8sOsDM7zAtIijWLpw--";
var _7 = "oFmzJdo2FX9cAWNO830qjg--";
export { _1 as "active", _2 as "dots", _3 as "link", _4 as "loading", _5 as "placeholder", _6 as "subLink", _7 as "subPlaceholder" }
